export const DEV_BOOTSTRAP_URI = 'https://icp-api.dev.apptrium.cloud/bootstrap';
export const UAT_BOOTSTRAP_URI = 'https://icp-api.uat.apptrium.cloud/bootstrap';
export const PROD_BOOTSTRAP_URI = 'https://icp-api.apptrium.cloud/bootstrap';

export interface BootstrapLocation {
  origin: string;
  /** `window.APP_ENV`, rendered into index.html. */
  appEnv?: string;
  /** `window.SWITCHBOARD_API`, rendered into index.html. */
  switchboardApi?: string;
  isDevelopment: boolean;
}

/**
 * The switchboard address index.html was rendered with, or undefined when it was not: an
 * empty value, or the `__SWITCHBOARD_API__` placeholder of a template nobody filled in.
 */
function renderedSwitchboard(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  if (!trimmed || /^__.*__$/.test(trimmed)) return undefined;
  return trimmed.replace(/\/+$/, '');
}

/**
 * Where the portal configuration comes from.
 *
 * The switchboard index.html names wins: a portal moved to another cluster — the DRP
 * recovery runs dev on new hostnames (PSDK-6582, DEVOPS-6844) — must take its config, and
 * with it its IdP, from that cluster's switchboard and not from the one its hostname
 * suggests. Every portal deployed so far renders the same address the fallback computes.
 * Local development keeps its own `/bootstrap`, which the dev server answers.
 */
export function selectBootstrapURI({
  origin,
  appEnv,
  switchboardApi,
  isDevelopment
}: BootstrapLocation): string {
  if (origin.includes('localhost') && isDevelopment) {
    return `${origin}/bootstrap`;
  }
  const switchboard = renderedSwitchboard(switchboardApi);
  if (switchboard) {
    return `${switchboard}/bootstrap`;
  }
  if (origin.includes('.sandbox.apptrium.cloud') || appEnv === 'DEV') {
    return DEV_BOOTSTRAP_URI;
  }
  if (origin.includes('.rc.apptrium.cloud') || appEnv === 'UAT') {
    return UAT_BOOTSTRAP_URI;
  }
  return PROD_BOOTSTRAP_URI;
}
